import { useEffect, useReducer, useRef } from 'react';
import formStateReducer from './form.state.reducer';
import _ from 'lodash';
import { initFormState } from './form.state.actions';

const useFormState = ({
  defaultValue = {},
  defaultSelectedCategory = null
}) => {
  const prevDefaultValue = useRef(defaultValue);
  const [formState, dispatch] = useReducer(formStateReducer, {
    ...defaultValue,
    selectedCategory: defaultSelectedCategory
  });

  const getSettingPayload = () =>
    _.omit(formState, ['selectedCategory', 'dispatch']);

  useEffect(() => {
    const hasDefaultValueChanged = !_.isEqual(
      prevDefaultValue.current,
      defaultValue
    );
    if (hasDefaultValueChanged) {
      prevDefaultValue.current = defaultValue;
      dispatch(initFormState({ ...defaultValue }));
    }
  }, [defaultValue]);

  return {
    ...formState,
    getSettingPayload,
    dispatch
  };
};

export default useFormState;
